/**
 * Header — landing + auth + dashboard ortak başlık
 *
 * useSession() ile authed/unauthed state'e göre nav değişir.
 */
import { useEffect, useState } from 'react';
import { Link } from 'wouter';
import { useSession, signOut } from '../lib/auth-client.js';
import { api } from '../lib/api.js';

export function Header(): JSX.Element {
  const { data: session, isPending } = useSession();
  const isAuthed = !!session?.user;
  const [isStaff, setIsStaff] = useState(false);

  useEffect(() => {
    if (!isAuthed) {
      setIsStaff(false);
      return;
    }
    api
      .get<{ isBmuStaff?: boolean } | null>('/api/auth-extras/me')
      .then((me) => setIsStaff(!!me?.isBmuStaff))
      .catch(() => setIsStaff(false));
  }, [isAuthed, session?.user?.id]);

  return (
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link href="/" className="text-2xl font-bold tracking-tight">
          <span className="text-blue-900">BMU</span>
          <span className="text-sky-500">Works</span>
          <span className="ml-2 text-sm font-medium text-slate-500">SkillProbe</span>
        </Link>
        <nav className="flex items-center gap-6 text-sm font-medium text-slate-700">
          {!isPending && !isAuthed && (
            <>
              <a href="/#nasil" className="hidden hover:text-blue-900 sm:inline">
                Nasıl Çalışır
              </a>
              <a href="/#sss" className="hidden hover:text-blue-900 sm:inline">
                SSS
              </a>
              <Link
                href="/yonetici/giris"
                className="rounded-lg bg-blue-900 px-4 py-2 text-white hover:bg-blue-800"
              >
                Giriş Yap
              </Link>
            </>
          )}
          {!isPending && isAuthed && (
            <>
              <Link
                href={isStaff ? '/admin/dashboard' : '/yonetici/dashboard'}
                className="hover:text-blue-900"
              >
                Panel
              </Link>
              {isStaff && (
                <Link
                  href="/admin/dashboard"
                  className="rounded-md border border-purple-700 px-2 py-0.5 text-xs font-medium text-purple-700 hover:bg-purple-50"
                  title="BMU iç ekip paneli"
                >
                  ADMIN
                </Link>
              )}
              <span className="hidden text-slate-500 sm:inline">
                {session?.user.email}
              </span>
              <button
                type="button"
                onClick={async () => {
                  await signOut();
                  window.location.href = '/';
                }}
                className="rounded-lg border border-slate-300 px-3 py-1.5 text-slate-700 hover:bg-slate-50"
              >
                Çıkış
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
